var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMaxMinimize48Line = function SvgIconMaxMinimize48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.58 8.3H20.42a5.13 5.13 0 0 0-5.12 5.12v1.88h-1.7a5.31 5.31 0 0 0-5.3 5.3v13.8a5.31 5.31 0 0 0 5.3 5.3h13.8a5.31 5.31 0 0 0 5.3-5.3v-1.7h1.7a5.31 5.31 0 0 0 5.3-5.3v-14a5.13 5.13 0 0 0-5.12-5.1ZM29.3 34.4a1.9 1.9 0 0 1-1.9 1.9H13.6a1.9 1.9 0 0 1-1.9-1.9V20.6a1.9 1.9 0 0 1 1.9-1.9h13.8a1.9 1.9 0 0 1 1.9 1.9v13.8Zm7-7a1.9 1.9 0 0 1-1.9 1.9h-1.7v-8.7a5.31 5.31 0 0 0-5.3-5.3h-8.7v-1.88a1.72 1.72 0 0 1 1.72-1.72h14.16a1.72 1.72 0 0 1 1.72 1.72V27.4Z",
    fill: "current"
  })));
};
export default SvgIconMaxMinimize48Line;